import { Wizard } from "@evergis/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDialogWizardContext } from "../DialogComponents/DialogWizard/DialogWizardContext";
import { NewLayerStep } from "./types";

export const NewLayerTitleWizard = () => {
  const { t } = useTranslation("dialogs");
  const { step } = useDialogWizardContext();

  return (
    <Wizard
      currentStep={step}
      steps={[
        {
          label: t("newLayer.setFieldTypeAndName"),
          disabled: false,
        },
        {
          label: t("newLayer.setAttributes"),
          disabled: step < NewLayerStep.Attributes,
        },
      ]}
    />
  );
};
